import { RemoteGetPortalContatos } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import { PortalContatos } from '@/domain/usecases'
import env from '@/main/config/env'

export const makeGetPortalContatos = (): PortalContatos => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<PortalContatos.Result>()

  return new RemoteGetPortalContatos(url, httpClient)
}
